<script>
export default {
  name: 'agendas-search-results-covenant',
  props: {
    covenant: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<template lang="pug">
  span {{ covenant.name }}
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/covenant/covenant.vue